// This file contain all API URL (do not change the case for text)
// python manage.py runserver 127.0.0.1:8000
const SERVER_URL = "http://ec2-3-231-235-244.compute-1.amazonaws.com";

const URL_PATH = "/api/v1/join-me-api/";

export const URL_IP = SERVER_URL; // python manage.py runserver 127.0.0.1:8000
const URL = URL_IP + URL_PATH; // Use LOCALHOST_URL whenever backend is running on localhost

const AUTHENTICATION = {
  LOGIN: URL + "admin-sign-in/",
  EMAIL_VERIFICATION: URL + "email-verification/",
  RESEND_EMAIL_OTP: URL + "resend-email-otp/",
};

const EVENTS = {
  EVENT: URL + "admin-cinc-details/",
  CATEGORIES: URL + "event-categories/",
  EVENT_REMOVE_PARTICIPANT: URL + "admin-remove-cinc-participants/",
  EVENT_SEARCH_PARTICIPANT: URL + "admin-search-cinc-participants/",
};

const USER = {
  USERS: URL + "admin-user-crud/",
  SINGLE_USER: URL + "admin-single-user-detail/",
  USER_STATUS: URL + "admin-active-deactive-account/",
};
const REPORT = {
  REPORTS: URL + "report-issues/",
};
const DASHBOARD = {
  HOME: URL + "admin-dashboard/",
};

const GALLERY = {
  GALLERY: URL + "event-gallery-analytics/",
};

export { AUTHENTICATION, EVENTS, USER, REPORT, DASHBOARD, GALLERY };
